import { AnyAction } from 'redux';
import { RESET_LAUNCH, SET_SAML_BODY, SET_SAML_METHOD, SET_REDIRECT_AFTER_SIGNIN } from '@app/store/constants';
import { ILaunchState } from '@app/models';

const initialState: ILaunchState = {
    samlBody: '',
    samlMethod: '',
    redirectAfterSignin: '',
};

export function launch(state = initialState, action: AnyAction) {
    const { payload, type } = action;

    switch (type) {
        case RESET_LAUNCH:
            return initialState;

        case SET_SAML_BODY:
            return {
                ...state,
                samlBody: payload,
            };

        case SET_SAML_METHOD:
            return {
                ...state,
                samlMethod: payload,
            };

        case SET_REDIRECT_AFTER_SIGNIN:
            return {
                ...state,
                redirectAfterSignin: payload,
            };

        default:
            return state;
    }
}
